import PageMixins from '../../../components/_mixins/pages'
import CartMixin from 'shop/orders/_mixins/cart'
import ScrollMixins from '../../../components/_mixins/scroller'
import MainService from '../../../services/main'

export default {
  name: 'cart-final',
  settings: 'page.cart.cart-final',
  translations: 'page.cart.cart-final',
  mixins: [
    PageMixins,
    CartMixin,
    ScrollMixins
  ],

  props: ['items', 'order', 'waiverUrl'],

  data() {
    return {
      resendOrderConfirmationCount: -1,
      resendRegistrationVerificationCount: -1,
      email: null,
      showVerificationPrompt: false,
      isProcessing: false,
      showOrderEmailSuccess: false,
      showUserVerificationEmailSuccess: false,
    }
  },

  computed: {
    waiverEligible() {
      return _.some(this.items || {}, item => item.showWaiver)
    },

    affecTvId() {
      return window.addiesaas.supercharged.affec_tv?.id
    },

    affecTvScriptSrc() {
      const items = Object.values(this.order.items.data)

      const data = {
        ver: 'Retail',
        pnm: items.map(i => i.product.data.name).join(', '),
        pid: items.map(i => i.product.data.id).join(', '),
        pscat: '',
        pscid: '',
        pct: items.map(i => i.product.data.type).join(', '),
        cid: '',
        rev: this.order.total,
        cur: 'USD',
        cpn: '',
        url: window.location.href,
        mem: '',
        oid: this.order.invoice_number,
        qty: '',
        custom1: '',
        custom2: '',
        custom3: '',
      }

      const query = new URLSearchParams(data).toString()

      return `https://go.affec.tv/j/${this.affecTvId}?${query}`
    },
  },

  created() {
    this.email = this.order.user.data.email
    const isRegistered = this.isPreCheckoutRegistration
    this.setIsPreCheckoutRegistration(false)
    if (isRegistered) {
      const user = this.authUser
      if (!user.verified) {
        this.showVerificationPrompt = true
      }
    }

    this.trackOnlyGiftcards(this.order.items.data)
  },

  mounted() {
    this.resendOrderConfirmationCount = 0
    this.resendRegistrationVerificationCount = 0
    this.$nextTick(() => {
      // console.log('mounted final')
      this.scrollToTop()
    })
  },

  methods: {
    async notifyOrder() {
      try {
        this.isProcessing = true
        this.showOrderEmailSuccess = false
        const data = await MainService.notifyOrder(this.order)
        this.resendOrderConfirmationCount++
        this.showOrderEmailSuccess = true
        // this.alert(`The order confirmation has been resent to the following email address ${ this.email }.`)
      } catch (e) {
        this.alert('Error re-sending order confirmation. Please try again.')
      }
      this.isProcessing = false
    },
    async sendUserEmailVerification() {
      try {
        this.isProcessing = true
        this.showUserVerificationEmailSuccess = false
        const data = await MainService.sendConfirmation(this.email)
        // this.alert(`The confirmation has been resent to the following email address ${ this.email }.`)
        this.resendRegistrationVerificationCount++
        this.showUserVerificationEmailSuccess = true
      } catch (e) {
        this.alert('Error re-sending confirmation. Please try again.')
      }
      this.isProcessing = false
    },

    trackOnlyGiftcards(items) {
      const hasGiftcards = items.filter(x => x.product.data.type == 'giftcard').length
      const hasNonGiftcards = items.filter(x => x.product.data.type != 'giftcard').length

      if (hasGiftcards && !hasNonGiftcards) {
        if (typeof window.captureAdWordsGoal !== 'undefined') {
          window.captureAdWordsGoal('6icKCLnmwLMBEKHeyNoC')
        }
      }
    }
  }
}
